import { NgModule, Optional, SkipSelf } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthGuard } from './core/auth/auth.guard';
import { environment } from 'src/environments/environment';

export const appRoutingPaths = {
  login: 'login',
  authentication: 'authentication',
  empty: '',
  addApplication: 'add-application'
};

const appRoutes: Routes = [
  {
    path: appRoutingPaths.addApplication,
    loadChildren: () => import('./features/publicPage/condidates/create/create.module').then((m) => m.CreateModule),
  },
  {
    path: appRoutingPaths.login,
    loadChildren: () => import('./authentication/login/login.module').then((m) => m.LoginModule),
    pathMatch: 'full',
    data: {
      breadcrumb: 'LOGIN',
    },
  },
  {
    path: appRoutingPaths.authentication,
    redirectTo: appRoutingPaths.login,
  },
  {
    path: appRoutingPaths.empty,
    loadChildren: () => import('./layout/layout.module').then((m) => m.LayoutModule),
    canLoad: [AuthGuard],
    pathMatch: 'full',
  },
];

@NgModule({
  imports: [
    RouterModule.forRoot(appRoutes, {
      useHash: true,
      enableTracing: !environment.production,
      onSameUrlNavigation: 'reload',
    }),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule {
  constructor(@Optional() @SkipSelf() parentModule: AppRoutingModule) {
    if (parentModule) {
      throw new Error('AppRoutingModule is already loaded. Import it in the AppModule only.');
    }
  }
}
